class MrBannerHighlighter extends HTMLElement {
	#observer: IntersectionObserver;

	constructor() {
		super();

		let rootMargin = '-40% 0px -40% 0px';
		if ( window.matchMedia( '(min-aspect-ratio: 1)' ).matches ) {
			rootMargin = '-30% 0px -30% 0px';
		}

		this.#observer = new IntersectionObserver( ( entries ) => {
			entries.forEach( ( entry: IntersectionObserverEntry ) => {
				if ( entry.isIntersecting ) {
					entry.target.setAttribute( 'data-is-highlighted', '' );
				} else {
					entry.target.removeAttribute( 'data-is-highlighted' );
				}
			} );
		}, {
			threshold: 0.5,
			rootMargin: rootMargin,
		} );
	}

	connectedCallback(): void {
		this.#observer.observe( this );
	}

	disconnectedCallback(): void {
		this.#observer.disconnect();
	}
}

customElements.define( 'mr-banner-highlighter', MrBannerHighlighter );
